import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  border: 2px solid ${({ theme }) => theme.colors.primary};
  background: ${({ theme }) => theme.colors.background_white};
`;

export const Content = styled.div`
  margin: 2rem;
  height: 30rem;
  width: 20rem;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 5px #0000003b;
  @media (min-width: 450px) {
    width: 25rem;
  }
  @media (min-width: 600px) {
    width: 35rem;
  }
  @media (min-width: 810px) {
    width: 45rem;
  }

  .titlePointMap{
    margin-bottom: 5rem;
  }
`;
